module.exports = __webpack_public_path__ + "static/media/instantPaySmallIcon.6f9ddd3f.svg";